/**
 * Authentication configuration
 */

/** Access token lifespan in minutes */
export const ACCESS_TOKEN_LIFESPAN_MINUTES = 24 * 60; // 24 hours

/** Refresh token lifespan in days */
export const REFRESH_TOKEN_LIFESPAN_DAYS = 30; // 30 days

/** Helper to convert minutes to seconds */
export const minutesToSeconds = (minutes: number) => minutes * 60;

/** Helper to convert days to seconds */
export const daysToSeconds = (days: number) => days * 24 * 60 * 60;

/** Helper to convert seconds to milliseconds */
export const toMs = (seconds: number) => seconds * 1000;

/** Helper to get expiration date from now */
export const getExpirationDate = (seconds: number) => new Date(Date.now() + toMs(seconds));

/** Access token lifespan in seconds */
export const ACCESS_TOKEN_LIFESPAN_SECONDS = minutesToSeconds(ACCESS_TOKEN_LIFESPAN_MINUTES);

/** Refresh token lifespan in seconds */
export const REFRESH_TOKEN_LIFESPAN_SECONDS = daysToSeconds(REFRESH_TOKEN_LIFESPAN_DAYS);

/** 
 * Calculate refresh delay in milliseconds
 * Takes the larger of:
 * - access token lifespan - 15 minutes
 * - access token lifespan - 1 hour
 */
export const getRefreshDelay = () => {
  const fifteenMinutes = minutesToSeconds(15);
  const oneHour = minutesToSeconds(60);
  const delayInSeconds = Math.max(
    ACCESS_TOKEN_LIFESPAN_SECONDS - fifteenMinutes,
    ACCESS_TOKEN_LIFESPAN_SECONDS - oneHour
  );
  return toMs(delayInSeconds);
}; 